import PromoCode from './PromoCode.component';
export default PromoCode;